import { render, staticRenderFns } from "./CfgBloqueioAcesso.vue?vue&type=template&id=006644f8&"
import script from "./CfgBloqueioAcesso.vue?vue&type=script&lang=js&"
export * from "./CfgBloqueioAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports